import factory from '../requestFactory';
import store from '@/store'

export default ({service_id,timetable_id,name,birthday,phone,sms_code,sms_token}) => {
    let params = {
        service_id,
        name,
        birthday,
        phone,
        pay: 0,
        reserve: 1,
        need_callback: 1,
        sms_code,
        sms_token

    }


    return factory()
        .get(`/time-table/${timetable_id}/order`, {params: params})

};
